module.exports = __webpack_public_path__ + "static/media/red.8f9f079d.jpg";